import angular from "angular";

angular
    .module('app')
    .component('courseExtraInfo', {
        template: require('./course-extra-info.html'),
        controller: ['$http', '$timeout', 'ErrorResponseParser', 'Notifier', controller],
        bindings: {
            course: '<'
        }
    });

function controller($http, $timeout, ErrorResponseParser, Notifier) {

    let $ctrl = this;

    $ctrl.types = [
        {field: 'what_you_will_learn_data', key: 'what_you_will_learn_list', label: 'Что вы узнаете'},
        {field: 'requirements_data', key: 'requirements_list', label: 'Требования'},
        {field: 'who_should_attend_data', key: 'who_should_attend_list', label: 'Кто должен посещать'}
    ];


    $ctrl.$onInit = function () {

        $ctrl.what_you_will_learn_data = $ctrl.course.what_you_will_learn_list;
        $ctrl.requirements_data = $ctrl.course.requirements_list;
        $ctrl.who_should_attend_data = $ctrl.course.who_should_attend_list;

        $timeout(function () {
            $ctrl.types.forEach(function (type) {
                if (!$ctrl.course[type.key].length) {
                    $ctrl.course[type.key] = [''];
                }
            });
        });
    };


    $ctrl.submit = function () {

        $ctrl.loading = true;

        let params = {
            what_you_will_learn_list: $ctrl.course.what_you_will_learn_list,
            requirements_list: $ctrl.course.requirements_list,
            who_should_attend_list: $ctrl.course.who_should_attend_list,
        };

        $http.post('/admin/courses/' + $ctrl.course.id + '/save-extra-info', params).then(
            function (response) {
                $ctrl.loading = false;
                Notifier.success('Данные успешно обновлены', 2);
            },
            function (error) {
                $ctrl.loading = false;

                if (error.status == 422) {
                    $ctrl.validationErrors = error.data.errors;
                    Notifier.error('Ошибка при заполнении', 2);
                }

            }
        );
    };



    $ctrl.add = function (type) {
        $ctrl.course[type.key].push('');
    };

    $ctrl.changePos = function (type, ind, dir) {
        let arr = $ctrl.course[type.key];
        if (dir === 'up' && ind > 0) {
            let tmp = arr[ind - 1];
            arr[ind - 1] = arr[ind];
            arr[ind] = tmp;
        }
        if (dir === 'down' && ind + 1 < arr.length) {
            let tmp = arr[ind + 1];
            arr[ind + 1] = arr[ind];
            arr[ind] = tmp;
        }
    };

    $ctrl.delItem = function (type, ind) {
        $ctrl.course[type.key].splice(ind, 1);
    };


}
